import React, { useEffect,useState } from 'react';

function UserComponent({ userID }) {
    const [user, setUser] = useState(null);

    useEffect(() => {
        fetch(`https://dummyjson.com/user/${userID}`)
            .then(response => response.json())
            .then(userData => setUser(userData));

        return ()=>{
        };
    }, [userID]);
    return (
        <div>
            {user ? (
                <div>
                    <h1>{user.firstName} {user.lastName}</h1>
                    <p>{user.email}</p>
                </div>
            ) : (
                <p>Loading...</p>
            )}
        </div>
    );
    // Effect re-runs only if userID changes
}

export default UserComponent